import open from "webmodals/open";
import controller from "emun.cart/new-item/cart-new-item.controller";
import templateUrl from "emun.cart/new-item/cart-new-item.htm";

export default ({
	size = "md",
	backdrop = "static",
	placement = "center",
	preventAutoHeight = true,
	title = `Create Item`,
	product = {}
}) =>
  open({
    size,
    backdrop,
    templateUrl,
    placement,
    controller,
    resolve: {
      preventAutoHeight: () => preventAutoHeight,
      title: () => title,
      product: () => product
    },
    bindToController: true,
    controllerAs: "$ctrl"
  }).result;
